@let hasSegments = builderStore.hasSegmentsSg();
@let presentOverflowActions = builderStore.presentOverflowActionsSg();
@let switchingSegmentConfiguration =
  builderStore.switchingSegmentConfigurationSg();
@let markedForDiscard = builderStore.markedForDiscardSg();

<atn-ds-page class="atn-mosaic-page-builder">
  <!-- TODO Add title, breadcrumbs etc. -->
  <!-- <atn-ds-page-header pageHeader></atn-ds-page-header> -->

  <div class="atn-mosaic-page-builder__body">
    @if (hasSegments) {
      <div class="atn-mosaic-page-builder__body-aside">
        <atn-page-builder-segments />
      </div>
    }

    <div class="atn-mosaic-page-builder__content">
      <gridstack [options]="gridOptions"></gridstack>
    </div>

    <div
      class="atn-mosaic-page-builder__overflow-actions-origin"
      #overlayOrigin
      (click)="
        builderStore.patchState({
          presentOverflowActions: !presentOverflowActions,
        })
      "
    >
      <i
        class="atn-icon atn-light"
        [class.atn-menu-basic]="!presentOverflowActions"
        [class.atn-close-basic]="presentOverflowActions"
      ></i>
    </div>
  </div>
</atn-ds-page>

<atn-mosaic-dev-widget-selector />

<atn-mosaic-page-configuration-dialog />

<atn-mosaic-page-segment-dialog />

<atn-page-builder-overflow-actions [origin]="overlayOrigin" />

@if (switchingSegmentConfiguration) {
  <atn-ds-confirmation-overlay
    title="Optimize Segment Layout"
    description="The current layout is invalid. If you continue, the system will automatically optimize this segment's layout before navigating to the next segment. To make changes manually, click Cancel."
    confirmButtonText="Confirm"
    [confirmButtonStyle]="confirmLayoutOptimizationButtonStyle"
    (confirm)="confirmClickHandler()"
    (cancel)="cancelSegmentOptimizeClickHandler()"
  />
}

@if (markedForDiscard) {
  <atn-ds-confirmation-overlay
    title="Cancel"
    description="Are you sure you want to cancel? Unsaved changes will be discarded."
    confirmButtonText="Yes"
    [confirmButtonStyle]="confirmDiscardButtonStyle"
    (confirm)="discardChangesBtnClickHandler()"
    (cancel)="cancelDiscardBtnClickHandler()"
  />
}
